import { GET_BOARD_POLICIES } from '../../constants/actions/policies';

export function getBoardPolicies(payload) {
    return {
        type: GET_BOARD_POLICIES,
        payload,
    };
}
